<template>
  <Transition
    enter-active-class="duration-300 ease-bounce"
    enter-from-class="translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="duration-300 ease-bounce"
    leave-from-class="translate-x-0"
    leave-to-class="translate-x-full"
  >
    <div
      v-if="open"
      class="absolute inset-y-0 right-0 flex flex-col overflow-hidden overflow-y-auto border-border bg-background transition-all motion-reduce:transition-none"
      :class="surface.class"
      :style="surface.style"
      style="box-shadow: -4px 0px 12px rgba(0, 0, 0, 0.1)"
    >
      <DrawerPortal.Outlet />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useDrawerSurface } from "@/design_system/Drawer/layout";
import * as DrawerPortal from "@/design_system/Drawer/Portal";

const open = DrawerPortal.useIsPortalOpen();
const surface = useDrawerSurface();
</script>
